/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
import _ from 'lodash';
import RoleTypeTag from '../components/RoleTypeTag';
import MySkeleton from '../../../components/Skeleton';
import ChatAvatarComponent from './chat/ChatAvatarComponent';

interface CommunitySidebar {
  loading?: boolean;
}

const CommunitySidebar: React.FC<any> = ({ mem, selectedMember, onClickOnUserIcon, loading, openFilter }) => {
  const isActive: any = mem?.id === selectedMember?.id;
  const cat: any = mem?.category;

  const refrence: any = useRef(null);

  useEffect(() => {
    mem?.id === selectedMember?.id && refrence?.current?.scrollIntoView();
  }, [refrence?.current]);

  const formatBio = (name1: string, name2: string) => {
    if (!name1 || !name2) {
      return '';
    }
    return (
      <>
        <Typography noWrap color={isActive ? '#FFFFFF !important' : '#68717A'}>
          {name1.concat(',').concat(name2)}
        </Typography>
      </>
    );
  };

  const getBio = (mem: any) => {
    const category: any = mem?.category;
    const major: string = mem?.bio?.education?.major;
    const university: string = mem?.bio?.education?.university;
    const role: any = mem?.bio?.workHistory?.role;
    const company: any = mem?.bio?.workHistory?.companyName;

    return category === 'Student' ? formatBio(major, university) : formatBio(role, company);
  };

  // const getName = (mem: any) => {
  //   const chatProfileFirstName: any = _.get(mem, 'id.firstName', '');
  //   const chatProfileLastName: any = _.get(mem, 'id.lastName', '');

  //   return chatProfileFirstName
  //     ?.charAt(0)
  //     ?.toUpperCase()
  //     ?.concat(chatProfileFirstName?.slice(1)?.toLowerCase())
  //     ?.concat(
  //       ' ',
  //       chatProfileLastName?.charAt(0)?.toUpperCase()?.concat(chatProfileLastName?.slice(1)?.toLowerCase())
  //     );
  // };

  return (
    <Box
      sx={{
        width: '100%',
        cursor: 'pointer',
        px: 3,
        py: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        backgroundColor: isActive
          ? 'var(--Fill-Table-table-listItem-highlight, rgba(255, 255, 255, 0.02))'
          : 'transparent',
        borderBottom: '1px solid var(--Stroke-divider, #2A2A2A)'
      }}
      onClick={() => {
        onClickOnUserIcon(mem);
      }}
      ref={refrence}
    >
      <Box>
        <ChatAvatarComponent
          image={mem?.headshot}
          type="noStatus"
          firstLetter={mem?.displayName.charAt(0)}
          width="48px"
          height="48px"
          loading={loading}
        />
      </Box>
      <Box width="100%" minWidth={0}>
        <Box display="flex" alignItems="center" justifyContent="space-between" gap="5px">
          <Typography
            variant="h5"
            noWrap
            sx={{
              color: isActive ? 'var(--Text-text-primary, #FDFDFD)' : 'var(--Text-text-secondary, #B6B6B6)'
            }}
            flex={1}
            minWidth={0}
          >
            {loading ? <MySkeleton variant="text" height="16px" width={150} /> : _.get(mem, 'displayName', '')}
          </Typography>

          <RoleTypeTag category={mem?.category} loading={loading} place="community" />
        </Box>
        <Box width="100%" minWidth={0}>
          {loading ? (
            <MySkeleton variant="text" height="14px" width="100%" />
          ) : (
            <Typography
              sx={{
                color: 'var(--Text-text-secondary, #B6B6B6)',
                fontSize: '12px',
                lineHeight: '16px'
              }}
            >
              {getBio(mem)}
            </Typography>
          )}
        </Box>
      </Box>

      {/* <Box>
        <MoreVertIcon color='primary' />
      </Box> */}
    </Box>
  );
};
export default CommunitySidebar;
